import loadable from '@loadable/component';
import productCollectionSitemapPageQuery from './query.graphql';

const productCollectionSitemap = loadable(() =>
  import(
    /* webpackChunkName: "product-collection" */ './product-collection-sitemap'
  )
);

productCollectionSitemap.graphQL = productCollectionSitemapPageQuery;

productCollectionSitemap.loadOrder = [{ main: true }];

productCollectionSitemap.variables = ({ slug }) => ({
  slug,
});
// eslint-disable-next-line prettier/prettier

export default productCollectionSitemap;
